
export const banksList = [
    "State Bank of India",
    "HDFC Bank",
    "ICICI Bank",
    "Axis Bank",
    "Punjab National Bank",
    "Bank of Baroda",
    "Kotak Mahindra Bank",
    "IDFC First Bank",
    "Yes Bank",
    "Indian Bank",
    "Canara Bank",
    "Union Bank of India",
    "Bank of India",
    "Central Bank of India",
    "Indian Overseas Bank",
    "Andhra Bank",
    "Corporation Bank",
    "Dena Bank",
    "Vijaya Bank",
    "RBL Bank",
    "IDBI Bank",
    "Federal Bank",
    "Bajaj Finserv",
    "Laxmi Vilas Bank",
    "UCO Bank",
    "Syndicate Bank",
    "Bank of Maharashtra",
    "Tamilnad Mercantile Bank",
    "Karur Vysya Bank",
    "Shamrao Vithal Co-operative Bank",
    "Nainital Bank",
    "Bharat Co-operative Bank",
    "Airtel Payments Bank",
    "Fino Payments Bank",
    "Paytm Payments Bank",
    "India Post Payments Bank"
  ];